import { FormControl, InputLabel, MenuItem, Select, BaseSelectProps } from '@mui/material';
import { SupportedLanguageCode } from '@procureai/schemas';
import { useUuid } from '@procureai/ui-mui';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

export interface LanguageSelectProps extends BaseSelectProps {
  items: SupportedLanguageCode[];
  hasNone?: boolean;
}

export const LanguageSelect = ({ value, items, hasNone, ...props }: PropsWithChildren<LanguageSelectProps>) => {
  const { t } = useTranslation(I18nNamespace.languages);
  const id = useUuid();
  return (
    <FormControl size="small" fullWidth>
      <InputLabel id={id}>{props.label}</InputLabel>
      <Select sx={{ textAlign: 'center' }} labelId={id} {...props} value={value || ''}>
        {hasNone ? <MenuItem value="">None</MenuItem> : null}
        {items.map((item) => (
          <MenuItem key={item} value={item}>
            {t(item)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
